import React from 'react';
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { Button, DatePicker } from 'antd';
import './index.scss';
import TextArea from '../../../../components/forms/BuilderTextArea';
import DescriptionSuggestion from '../DescriptionSuggestion';
import dayjs from 'dayjs';

const EmploymentHistoryStep = (props) => {
  const { params, onChange } = props;
  const experience = params.experience || [];

  const onContinueClick = () => {
    props.onContinueClick && props.onContinueClick();
  };
  const onBackClick = () => {
    props.onBackClick && props.onBackClick();
  };

  const handleFieldChange = (idx, field, value) => {
    const updated = experience.map((job, i) =>
      i === idx ? { ...job, [field]: value } : job
    );
    onChange('experience', updated);
  };

  const handleDateChange = (idx, field, date) => {
    if (!date) {
      handleFieldChange(idx, field, { month: '', year: '' });
      return;
    }
    handleFieldChange(idx, field, {
      month: parseInt(date.format('MM')),
      year: parseInt(date.format('YYYY')),
    });
  };

  const addJob = () => {
    onChange('experience', [
      ...experience,
      {
        companyName: '',
        jobPosition: '',
        startDate: { month: '', year: '' },
        endDate: { month: '', year: '' },
        isPresent: false,
        description: '',
        location: '',
      },
    ]);
  };

  const removeJob = (idx) => {
    onChange('experience', experience.filter((_, i) => i !== idx));
  };

  const generateSuggestionKey = (idx, jobTitle, companyName) => {
    return `job_${idx}_${jobTitle || 'untitled'}_${companyName || 'unknown'}`.replace(/\s+/g, '_').toLowerCase();
  };

  const handleAddSuggestion = (idx, suggestion) => {
    handleFieldChange(idx, 'description', suggestion);
  };

  return (
    <div className="step employment-history-step">
      <div className="step-inner-content">
        <div className="step-header">
          <h2>Employment history</h2>
          <p>Show employers your past experience and what you have accomplished. Include simple, clear examples with action verbs to demonstrate your skills.</p>
        </div>
        {(experience?.length === 0 ? [] : experience).map((job, idx) => {
          let startDate = job.startDate?.month && job.startDate?.year ? dayjs(new Date(job.startDate.year, job.startDate.month)) : null;
          let endDate = job.endDate?.month && job.endDate?.year ? dayjs(new Date(job.endDate.year, job.endDate.month)) : null;
          // if (job.isPresent) {
          //   endDate = dayjs();
          // }
          return (
            <div className="job-card" key={idx}>
              <div className="job-card-header">
                <span className="job-title">{job.jobPosition || 'Untitled'}</span>
                <span className="job-card-actions">
                  <button className="job-card-delete" title="Delete job" onClick={() => removeJob(idx)}>🗑️</button>
                </span>
              </div>
              <div className="job-fields">
                <div className="row">
                  <div className="field">
                    <label>Job title</label>
                    <input
                      type="text"
                      placeholder="Rocket Scientist"
                      value={job.jobPosition || ''}
                      onChange={e => handleFieldChange(idx, 'jobPosition', e.target.value)}
                    />
                  </div>
                  <div className="field">
                    <label>Company</label>
                    <input
                      type="text"
                      placeholder="NASA"
                      value={job.companyName || ''}
                      onChange={e => handleFieldChange(idx, 'companyName', e.target.value)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="field">
                    <label>Start date</label>
                    <DatePicker
                      style={{ width: '100%' }}
                      picker="month"
                      placeholder="Jan 2016"
                      format="MM/YYYY"
                      value={startDate}
                      onChange={date => handleDateChange(idx, 'startDate', date)}
                    />
                  </div>
                  <div className="field">
                    <label>End date</label>
                    <DatePicker
                      style={{ width: '100%' }}
                      picker="month"
                      placeholder="Feb 2019"
                      format="MM/YYYY"
                      value={endDate}
                      onChange={date => handleDateChange(idx, 'endDate', date)}
                      disabled={job.isPresent}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                      <input
                        type="checkbox"
                        checked={job.isPresent || false}
                        onChange={e => handleFieldChange(idx, 'isPresent', e.target.checked)}
                        style={{ marginRight: 6 }}
                      />
                      Present
                    </label>
                  </div>
                  <div className="field">
                    <label>Location</label>
                    <input
                      type="text" className="location-input"
                      placeholder="Washington, D.C."
                      value={job.location || ''}
                      onChange={e => handleFieldChange(idx, 'location', e.target.value)}
                    />
                  </div>
                </div>
                <div className="row rich-row">
                  <div className="field rich-field">
                    <div className="description-wrapper">
                      <TextArea
                        className="job-description"
                        rows={4}
                        placeholder="Designed and developed the propulsion systems for the next generation of NASA's Mars rover vehicles.\n• Led a team of engineers in the successful launch and deployment of several satellite missions."
                        value={job.description || ''}
                        onChange={e => handleFieldChange(idx, 'description', e)}
                      />
                      <DescriptionSuggestion
                        flow="job" job={job}
                        selector={generateSuggestionKey(idx, job.jobPosition, job.companyName)}
                        resumeData={params}
                        onAdd={(suggestion) => handleAddSuggestion(idx, suggestion)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
        <div style={{ marginBottom: 24 }}>
          <button className="add-object-btn" onClick={addJob} style={{ width: '100%' }}>+ Add experience</button>
        </div>
      </div>
      <div className="step-footer">
        <button className="back-btn" onClick={onBackClick}>&larr; Back</button>
        <Button loading={props.formLoading} className="next-btn" onClick={onContinueClick}>Next <span className="arrow">&rarr;</span></Button>
      </div>
    </div>
  );
};

export default EmploymentHistoryStep;
